import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  NgZone,
  signal,
  Signal,
  ViewChild,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppState } from '../../store/app.state';
import { Store } from '@ngrx/store';
import { AuthActions } from '../../store/state/auth/auth.actions';
import { MatTooltip } from '@angular/material/tooltip';
import { AsyncPipe, NgIf } from '@angular/common';
import { UiDropdownComponent, UiAvatarComponent } from '@ui';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { UserModels, OrganizationModels } from '@share-models';
import { userFeature } from '../../store/state/user/user.feature';
import { organizationFeature } from '../../store/state/organization/organization.feature';
import {
  NAVIGATION_ITEMS,
  USER_NAVIGATION_ITEMS,
} from '../../consts/navigation.const';
import { PanicNavigationModels } from '../../models/navigation.model';
import { injectVisibleNavigationItems } from '../../helpers/navigation.helper';
import { SwitchOrganizationComponent } from './components/switch-organization/switch-organization.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTooltip,
    AsyncPipe,
    NgIf,
    UiDropdownComponent,
    UiAvatarComponent,
    RouterLink,
    RouterLinkActive,
    TranslatePipe,
    SwitchOrganizationComponent,
  ],
})
export class SidebarComponent implements AfterViewInit {
  private readonly store$ = inject(Store<AppState>);
  private readonly ngZone = inject(NgZone);

  @ViewChild('userMenu')
  public userMenu!: ElementRef<HTMLElement>;

  public userMenuHeight = 0;
  public readonly isOrgSelectorOpen = signal(false);
  public readonly userOrganizations = toSignal(
    this.store$.select(organizationFeature.selectUserOrganizations),
    { initialValue: [] as OrganizationModels.UserOrganizationDropDown[] },
  );

  public readonly selectUser$: Observable<UserModels.UserDocument | null> =
    this.store$.select(userFeature.selectProfile);

  public readonly selectActiveOrganization$: Observable<OrganizationModels.OrganizationDocument | null> =
    this.store$.select(organizationFeature.selectActiveOrganization);

  public readonly navigationItems: Signal<
    readonly PanicNavigationModels.ResolvedItem[]
  > = injectVisibleNavigationItems(NAVIGATION_ITEMS);

  public readonly userItems: readonly PanicNavigationModels.ResolvedItem[] =
    USER_NAVIGATION_ITEMS;

  public ngAfterViewInit(): void {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      if (this.userMenu) {
        this.userMenuHeight = this.userMenu?.nativeElement?.clientHeight ?? 0;
      }
    });
  }

  public logout(): void {
    this.store$.dispatch(AuthActions.logout({ msg: null }));
  }

  public toggleSwitchOrgMenu(): void {
    this.isOrgSelectorOpen.update((v) => !v);
  }

  public closeSwitchOrgMenu(): void {
    this.isOrgSelectorOpen.set(false);
  }
}
